/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, ReactNode, useEffect, useState } from "react";
import { getLocalStorage } from "data/cache/localstorage-cache";
import { UserLoggedInEntity } from "../../@types/entity/auth/user-logged-in-entity"
import { resolveAccessPermissions, roleNamesFromScope } from "helper/access-permission"
import { clearAuthLocalStorage } from "helper/logout-helper";
import { getStoredAuthToken, isStoredAuthValid, safeJwtDecode } from "helper/jwt-token-helper";
import { getEnv } from "helper/window-helper"

export const AuthContext = createContext({} as AuthContextType);

export type ProviderPropsType = { children: ReactNode };
export type AuthContextType = {
    isLoggedIn: boolean;
    updateIsLoggedIn: (status: boolean) => void;
    loggedUserData?: UserLoggedInEntity;
};

export function AuthProvider(props: ProviderPropsType) {
    /** IDENTIFICACAO PARA O LOCALSTORAGE */
    const TOKEN_USER_LOGIN = getEnv("REACT_APP_LOCALSTORAGE_TOKEN_USER_LOGIN")!
    const TOKEN_USER_CHANGE = getEnv("REACT_APP_LOCALSTORAGE_TOKEN_USER_CHANGE")!

    /** TOKEN VINDOS DO LOCALSTORAGE */
    const tokenLocalStorage: { token: string } =
        getLocalStorage(TOKEN_USER_LOGIN);
    const tokenLocalStorageChange: { token: string } | null =
        getLocalStorage(TOKEN_USER_CHANGE);
    const isSuperUserFromStorage = (() => {
      try {
        const stored = localStorage.getItem('is-super-user');
        return stored ? JSON.parse(stored) === true : undefined;
      } catch {
        return undefined;
      }
    })();

    /** USUARIO ESTA LOGADO */
    const [isLoggedIn, updateIsLoggedIn] = useState<boolean>(
        isStoredAuthValid(tokenLocalStorage) || isStoredAuthValid(tokenLocalStorageChange)
    );

    /** DADOS DO USUARIO LOGADO PARA TODA A APLICACAO */
    const [loggedUserData, updateLoggedUserData] =
        useState<UserLoggedInEntity>();

    /** INICIO */
    useEffect(() => {
        const activeToken = getStoredAuthToken(tokenLocalStorageChange)
            ?? getStoredAuthToken(tokenLocalStorage);

        if (!activeToken) {
            if (tokenLocalStorage || tokenLocalStorageChange) {
                clearAuthLocalStorage();
            }
            updateIsLoggedIn(false);
            return;
        }

        const decoded = safeJwtDecode<any>(activeToken);
        if (!decoded) {
            clearAuthLocalStorage();
            updateIsLoggedIn(false);
            return;
        }

        updateIsLoggedIn(true);

        const scope = decoded.scope ?? [];
        const role = roleNamesFromScope(scope);
        const isSuperUserFromJwt = decoded.superUser ?? decoded.isSuperUser ?? decoded.super_user ?? false;
        const isSuperUserFromScope = role.some((r: string) => r === 'SUPER_USER' || r === 'IS_SUPER_USER');
        const isSuperUser = isSuperUserFromStorage ?? (isSuperUserFromJwt || isSuperUserFromScope);
        updateLoggedUserData({
            role,
            access: resolveAccessPermissions(decoded),
            companyId: decoded.emp,
            id: decoded.sub,
            isSuperUser,
        });

        if (Date.now() >= decoded.exp * 1000) {
            localStorage.clear();
            location.reload();
        }
    }, []);

    return (
        <AuthContext.Provider
            value={{ isLoggedIn, updateIsLoggedIn, loggedUserData }}
        >
            {props.children}
        </AuthContext.Provider>
    );
}
